import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\WikiContact\AttachWikiContactToPlaceController::__invoke
* @see app/Http/Controllers/WikiContact/AttachWikiContactToPlaceController.php
* @route '/api/wiki-contact/{contact}/attach-to/{place_id}'
*/
const AttachWikiContactToPlaceController = (args: { contact: string | { id: string }, place_id: string | number } | [contact: string | { id: string }, place_id: string | number ], options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: AttachWikiContactToPlaceController.url(args, options),
    method: 'post',
})

AttachWikiContactToPlaceController.definition = {
    methods: ["post"],
    url: '/api/wiki-contact/{contact}/attach-to/{place_id}',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\WikiContact\AttachWikiContactToPlaceController::__invoke
* @see app/Http/Controllers/WikiContact/AttachWikiContactToPlaceController.php
* @route '/api/wiki-contact/{contact}/attach-to/{place_id}'
*/
AttachWikiContactToPlaceController.url = (args: { contact: string | { id: string }, place_id: string | number } | [contact: string | { id: string }, place_id: string | number ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            contact: args[0],
            place_id: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        contact: typeof args.contact === 'object'
        ? args.contact.id
        : args.contact,
        place_id: args.place_id,
    }

    return AttachWikiContactToPlaceController.definition.url
            .replace('{contact}', parsedArgs.contact.toString())
            .replace('{place_id}', parsedArgs.place_id.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\WikiContact\AttachWikiContactToPlaceController::__invoke
* @see app/Http/Controllers/WikiContact/AttachWikiContactToPlaceController.php
* @route '/api/wiki-contact/{contact}/attach-to/{place_id}'
*/
AttachWikiContactToPlaceController.post = (args: { contact: string | { id: string }, place_id: string | number } | [contact: string | { id: string }, place_id: string | number ], options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: AttachWikiContactToPlaceController.url(args, options),
    method: 'post',
})

export default AttachWikiContactToPlaceController